import React , { Component } from 'react';
import { connect } from 'react-redux';
import { Panel } from 'react-bootstrap';
import { FadeLoader } from 'react-spinners';
import Autocomplete from 'react-autocomplete';

import getListaBonos from '../../../../utils/getListaBonos';
//import updateEstado from '../../../utils/updateEstadoBonos';
import AgregarBonos from './AgregarBonos';
import { fetchFacturacion} from '../../../../actions';
import Alert from '../../../../components/Alert';
import getBonos from '../../../../utils/getBonos';
import getPedidosPedidos from '../../../../utils/getPedidosPedidos';
import updateEstadoVale from '../../../../utils/updateEstadoVale';
import editBonosVale from '../../../../utils/editBonosVale';
import {fetchColaboradores,clearColaboradores} from '../../../../actions';

export const ColorPill = (props) => {
  let pillClass;
  let descripcion;
  switch (props.estado) {
    case 'P':
      pillClass = 'pill pill-block pill-yellow';
      descripcion = 'Pendiente';
      break;
    case 'A':
      pillClass = 'pill pill-block pill-green';
      descripcion = 'Aprobado';
      break;
    case 'R':
      pillClass = 'pill pill-block pill-yellow';
      descripcion = 'Rechazado';
      break;
    case 'I':
      pillClass = 'pill pill-block pill-red';
        descripcion = 'Inactivado';
      break;
    default:
      pillClass = 'pill pill-block';
  }

  return (
    <span className={pillClass}>{descripcion}</span>
  );
};


const menuStyle = {
    position: 'absolute',
    left: '0',
    top: '100%',
    maxHeight: '350px',
    overflow: 'auto',
    border: '1px solid #cccccc',
  };

const inputProps = {
  className: 'form-control awesomplete pillSelct-input',
  name: 'colaborador',
};

const ModalBonos = props => (
  <div className={`modal in ${props.modalOpenvalue ? 'js-open' : ''}`}  role='dialog'>
    <div className={`modal-dialog ${props.modalSize}`} role='document'>
      <button className='btn btn-sm btn-blue modal-close' onClick={() => props.closeModal()}>Cerrar ventana</button>
      <div className='modal-content'>
        <div className='modal-body'>
          <h2 className='modal-title'>{props.title}</h2>

          <p className='h6 text-center'>
            {props.subtitle}
          </p>
                    {
                      props.listaPedidosXProforma.filter(entry => [... new  Set(props.listaPedidosModal.map(codFive => {return codFive.codFiveBono}))].indexOf(entry.codFiveBono)>=0 ).map(pedido =>
                        <p className='h6 text-center'>
                          {pedido.numPedidoVeh}
                        </p>
                      )
                    }
                    <br/>
                    <hr className='modalBleed' />


                                        <div className='form-group'>
                                          <div className='pillSelct'>
                                            <p className='labelInfo'>Notificar a un colaborador</p>
                                            <div className='pillSelct-field'>
                                            <div className='awesomplete'>
                                                <Autocomplete
                                                  getItemValue={item => item.idUsuario.toString()}
                                                  value={props.colaborador}
                                                  items={props.colaboradores}
                                                  renderItem={(item, isHighlighted) =>
                                                    <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                                                      {`${item.apellidos} ${item.nombre}`}
                                                    </div>
                                                  }
                                                  onChange={props.changeColaborador}
                                                  menuStyle={menuStyle}
                                                  inputProps={inputProps}
                                                  wrapperStyle={{ display: 'block' }}
                                                  onSelect={props.selectColaborador}
                                                />
                                              </div>
                                              <div className='pillSelct-pills'>
                                                {
                                                  props.colaboradoresSeleccionados.map((colaborador, idColaborador) => (
                                                    <label key={idColaborador} className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                                                      {colaborador.nombres}
                                                      <button
                                                        className='pillSelct-delete'
                                                        onClick={() => props.removeColaborador(colaborador.id)}
                                                      ><i className='icon ion-close pill-close' />
                                                      </button>
                                                    </label>
                                                  ))
                                                }
                                              </div>
                                            </div>
                                          </div>
                                        </div>

        <div className='modal-actions'>
          <button className='btn btn-default' onClick={ props.closeModal}>Cancelar</button>
          <button className='btn btn-primary pull-right' onClick ={() => props.actualizarBonoVale(props.listaPedidosModal,props.listaPedidosXProforma.filter(entry => [... new  Set(props.listaPedidosModal.map(codFive => {return codFive.codFiveBono}))].indexOf(entry.codFiveBono)>=0 ))} >Aceptar</button>
        </div>
        </div>
      </div>
    </div>
    </div>
);

const TabBonos = props => (
  <section className='fdv-section' id='proformas'>
        <header className='fdv-section-head' />

  {
        props.proformas.map((element,) => (

          <div key={`${element.numFichaVtaVeh}-${element.numProfVeh}`}>
                <div className='card card-plain card-lg' >

                <button className='card-lg-title btn-clean' onClick={() => {props.selectProforma(element.numProfVeh); props.clearProforma();}} >
                  <h3>Proforma - {element.numProfVeh}
                  {props.proformaSeleccionada === element.numProfVeh ? <i className='ion-chevron-down ml-3 c-cyan' /> : <i className='ion-chevron-up ml-3 c-cyan' />}
                   </h3>
                </button>

                <Panel collapsible expanded={props.proformaSeleccionada === element.numProfVeh} style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0' }}>
                <section className='fdv-section' id='bonosFDV'>
                <header className='fdv-section-head'>
                  <h5 className='fdv-section-title'>Bonos profroma</h5>
                  <div className='fdv-section-actions'>
                  <button className='btn btn-primary btn-sm active'
                    onClick={(e) => props.handlePermissions(e,element.numProfVeh) && props.openModal('AgregarBonos',props,undefined)}
                    data-permisos='ind_agregar_bono'>Generar bonos</button>
                  </div>
                </header>
                {[ ...new Set(props.listaPedidosXProforma.map(entry => {return entry.codFiveBono}))].map(codFiveBono =>
                <div className='card card-plain card-lg mb-3' style={{display:props.listaBonosXproforma.filter(Entity => Entity.numProfVeh === element.numProfVeh).length === 0 ? 'none':'block'}} >
                  <h6 className='h5 mb-3'>
                    <span className='bold'>N° Pedidos</span>
                    <span>
                    {
                      props.listaPedidosXProforma.filter(entry => entry.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh).map( pedido =>
                        (
                         <items> {pedido.numPedidoVeh} </items>
                        )
                        )
                    }

                    </span>
                  </h6>

                  <div className="autDetail-actions">
                    <div className="autDetail-actions-main">
                      <div className="autDetail-actions-item">
                      <p className='h5 bold'>Bono Total $
                          {
                            props.listaBonosXproforma.filter(entry => entry.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh).length > 0 ?(
                            props.listaBonosXproforma.filter(entry => entry.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh)[0].montoTotalBono):null
                          } - Número del Bono: {
                            props.listaBonosXproforma.filter(entry => entry.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh).length > 0 ?(
                            props.listaBonosXproforma.filter(entry => entry.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh)[0].codFiveBono):null
                          }       </p>
                      </div>

                    </div>
                    <div className="autDetail-actions-sec">
                        <div className="autDetail-actions-item">
                              <a className="btn btn-success active " onClick={() => props.modalOpenAcctionRechazarBonos(codFiveBono)}>
                                  <span>Rechazar</span>
                              </a>
                        </div>

                        <div className="autDetail-actions-item">
                              <a className="btn  btn-blue" onClick={() => props.modalOpenAcctionAprobarBonos(codFiveBono)}>
                                  <span>Aprobar</span>
                              </a>
                        </div>

                        <div className="autDetail-actions-item">
                              <a className="btn btn-danger active" onClick={() => props.modalOpenAcctionInactivarBonos(codFiveBono)}>
                                  <span>Inactivar</span>
                              </a>
                        </div>

                    </div>

                  </div>

                  <div className='tableWrapper hidden-xs'>
                    <table className='table table-hover'>
                      <thead className='table-head'>
                        <tr>
                          <th>Cant. Vales</th>
                          <th>Monto</th>
                          <th>Totales</th>
                          <th>E° Solicitud</th>
                        </tr>
                      </thead>
                      <tbody>
                     {
                       props.listaBonosXproforma.filter(entry => entry.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh).length > 0 ?(
                        props.listaBonosXproforma.filter(entry => entry.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh).map( pedido =>
                          (
                        <tr>
                          <td>{pedido.canValeBono}</td>
                          <td>{pedido.montoVale}</td>
                          <td>{pedido.montoValeTotal}</td>
                          <td>  <ColorPill
                                    estado ={pedido.codEstaVale}
                                />
                          </td>
                        </tr>
                          )
                          )
                       ):(
                        <tr>
                            <td colSpan='5'> No existe registros </td>
                        </tr>
                       )
                     }

                      </tbody>
                    </table>
                  </div>

                  <h5 className='fdv-section-title'>Observaciones</h5>
                  <p> {
                  }  </p>

                  <p class="mb-0"><span class="mr-2" dangerouslySetInnerHTML={props.printcontent(
                    props.listaBonosXproforma.filter(entry => entry.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh).length > 0 ?(
                    props.listaBonosXproforma.filter(entry => entry.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh)[0].obsMono):''
                  )}></span></p>



                </div>
                )}
                <br />
                <hr />
                <br />

                <header className='fdv-section-head'>
                  <h5 className='fdv-section-title'>Bono por cortesía</h5>
                  <div className='fdv-section-actions'>
                    <button className='btn btn-primary btn-sm active' data-toggle='modal' data-target='#fdv-agregarBonos' data-dismiss='modal' show='#cortesAct,#cortesSec,#cortesTL' hide='#path,#bonoAct,#bonoSec,#bonoTl' fdvequipslide='0'
                      onClick={(e) => props.handlePermissions(e,element.numProfVeh) && props.openModal('AgregarCortesia',props)}
                      data-permisos='ind_agregar_bono_cortesia'>Agregar cortesía
                    </button>
                  </div>
                </header>
                {[ ...new Set(props.listaPedidosXCortesia.map(entry => {return entry.codFiveBono}))].map(codFiveBono =>
                <div className='card card-plain card-lg mb-3'
                style={{display:props.listaBonoXCortesia.filter(bonoCotersia => bonoCotersia.codFiveBono===codFiveBono)
                  .filter(Entity => Entity.numProfVeh === element.numProfVeh).length === 0 ? 'none':'block'}} >
                  <h6 className='h5 mb-3'>
                    <span className='bold'>N° Pedidos</span>
                    <span>
                    {
                      props.listaPedidosXCortesia.filter(bonoCotersia => bonoCotersia.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh).map( pedido =>
                        (
                         <items> {pedido.numPedidoVeh} </items>
                        )
                        )
                    }


                    </span>
                  </h6>
                  <div className="autDetail-actions">
                  <div className="autDetail-actions-main">
                    <div className="autDetail-actions-item">
                    <p className='h5 bold'>Bono Total $
                          {
                            props.listaBonoXCortesia.filter(bonoCotersia => bonoCotersia.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh).length > 0 ?(
                            props.listaBonoXCortesia.filter(bonoCotersia => bonoCotersia.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh)[0].montoTotalBono):null
                          } - Número del Bono: {
                            props.listaBonoXCortesia.filter(bonoCotersia => bonoCotersia.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh).length > 0 ?(
                            props.listaBonoXCortesia.filter(bonoCotersia => bonoCotersia.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh)[0].codFiveBono):null
                          }   </p>
                    </div>

                  </div>
                  <div className="autDetail-actions-sec">
                      <div className="autDetail-actions-item">
                            <a className="btn btn-success active" onClick={() => props.modalOpenAcctionRechazar(codFiveBono)}>
                                <span>Rechazar</span>
                            </a>
                      </div>

                      <div className="autDetail-actions-item">
                            <a className="btn  btn-blue" onClick={() => props.modalOpenAcctionAprobar(codFiveBono)}>
                                <span>Aprobar</span>
                            </a>
                      </div>

                      <div className="autDetail-actions-item">
                            <a className="btn btn-danger active" onClick={() => props.modalOpenAcctionInactivar(codFiveBono)}>
                                <span>Inactivar</span>
                            </a>
                      </div>

                  </div>
                </div>                  <div className='tableWrapper hidden-xs'>
                    <table className='table table-hover'>
                      <thead className='table-head'>
                        <tr>

                          <th>Cant. Vales</th>
                          <th>Monto</th>
                          <th>Totales</th>
                          <th>E° Solicitud</th>
                        </tr>
                      </thead>
                      <tbody>
                            {
                            props.listaBonoXCortesia.filter(bonoCotersia => bonoCotersia.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh).length > 0 ?(
                              props.listaBonoXCortesia.filter(bonoCotersia => bonoCotersia.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh).map( pedido =>
                                (
                              <tr>
                                <td>{pedido.canValeBono}</td>
                                <td>{pedido.montoVale}</td>
                                <td>{pedido.montoValeTotal}</td>
                                <td>
                                <ColorPill
                                estado ={pedido.codEstaVale}
                                />
                                </td>
                              </tr>
                                )
                                )
                            ):(
                              <tr>
                                  <td colSpan='5'> No existe registros </td>
                              </tr>
                            )
                          }
                      </tbody>
                    </table>
                  </div>
                  <h5 className='fdv-section-title'>Observaciones</h5>

                  <p class="mb-0"><span class="mr-2" dangerouslySetInnerHTML={props.printcontent(
                     props.listaBonoXCortesia.filter(bonoCotersia => bonoCotersia.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh).length > 0 ?(
                     props.listaBonoXCortesia.filter(bonoCotersia => bonoCotersia.codFiveBono===codFiveBono).filter(Entity => Entity.numProfVeh === element.numProfVeh)[0].obsMono):null

                  )}></span></p>


                </div>
                )}
              </section>
                </Panel>
              </div>
        </div>

      ))
    }

  </ section >
);

const ESTADO_APROBADO = 'A';
const ESTADO_RECHAZADO = 'R';
const ESTADO_INACTIVAR = 'I';


class Bonos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectTipoBono:'BONOS',
      selecNumeroProforma:'',
      listaBonosXproforma:[],
      listaBonoXCortesia:[],
      listaPedidosXProforma:[],
      listaPedidosXCortesia:[],
      listaSelecedBonos:[],
      listaSeleceCortesia:[],
      muestraLoad:'none',
      modalOpenvalue:false,
      alertSuccessOpen:false,
      codMonedaBono:props.proformas[0].tipoMoneda,
      montoBonoProforma:0,
      isOpen:false,
      listaPedidosModal:[],
      nameModalValue:'',
      title:'',
      subtitle:'',
      flagModal:'',
      flagAccion:'',
      flagActionTab:'tab',
      statusAgregarBonos:0,
      step:1,
      pedidosToEditCodFiv:[],
      colaboradoresSeleccionados: [],
      colaborador:''
    }
  }


  selectColaborador = (key) => {
    const colaboradorSelected = this.state.colaboradoresSeleccionados.filter(colaborador => colaborador.id === key).length;

    if (!colaboradorSelected) {
      const nombres = this.props.colaboradores
        .filter(({ idUsuario }) => idUsuario.toString() === key)[0].nombre;
      const apellidos = this.props.colaboradores
        .filter(({ idUsuario }) => idUsuario.toString() === key)[0].apellidos;
      const colaborador = { id: key, nombres: `${apellidos} ${nombres}` };
      this.setState({ colaborador: '', colaboradoresSeleccionados: [...this.state.colaboradoresSeleccionados, colaborador] });
      this.props.clearColaboradores();
    }
  }

  componentDidMount() {

    if(this.props.proformas.length > 0 ){
      this.renderLoad();
    }

    const idsProformas = this.props.proformas.map(row => row.numProfVeh);

     getPedidosPedidos(this.props.fdvID, idsProformas).then((result) => {
       this.setState({ pedidosXfichaVenta: result });
     }).catch((error) => { console.log(error);  });

  }

  closeModal = () => this.setState({ isOpen: false,modalOpenvalue:false,colaboradoresSeleccionados:[] })

  nextStep = () => this.setState({ step: this.state.step + 1 })
  previousStep = () => this.setState({ step: this.state.step - 1 })

  clearProforma = () => {
    this.setState({
      listaSeleceCortesia:[],
      listaSelecedBonos:[],
    });
  }

  removeColaborador = (id) => {
    const { colaboradoresSeleccionados } = this.state;
    this.setState({ colaboradoresSeleccionados: colaboradoresSeleccionados.filter(colaborador => id !== colaborador.id) });
  }

  changeColaborador = (e) => {
    this.onChangeValue(e);
    if (e.target.value.length >= 2) {

      this.props.fetchColaboradores(e.target.value);
    } else if (e.target.value.length === 0) {
      this.props.clearColaboradores();
    }
  }

  onChangeValue = e => {
      this.setState({ [e.target.name]: e.target.value })
  }

  renderLoad = () => {
    getListaBonos(this.props.proformas[0].numFichaVtaVeh,'P').then((result) => {
      console.log('result.dataP',result.data);
      this.setState({listaBonosXproforma:result.data.bonos,
                     listaPedidosXProforma:result.data.bonosPedidos,
                      listaSelecedBonos:[],
                      listaSeleceCortesia:[]
                    });
    });

    getListaBonos(this.props.proformas[0].numFichaVtaVeh,'C').then((result) => {
      console.log('result.dataC',result.data);
      this.setState({listaBonoXCortesia:result.data.bonos,
                    listaPedidosXCortesia:result.data.bonosPedidos,
                    listaSelecedBonos:[],
                    listaSeleceCortesia:[]});
    });

    this.setState({step:1})


  }

  closeAlertSuccess = () =>{
    this.setState({alertSuccessOpen:false});
  }

  openAlertSuccess = () =>{
    this.setState({alertSuccessOpen:true});
  }

  eliminarObjetosDuplicados= (arr, prop)  => {
     var nuevoArray = [];
     var lookup  = {};

     for (var i in arr) {
         lookup[arr[i][prop]] = arr[i];
     }

     for (i in lookup) {
         nuevoArray.push(lookup[i]);
     }

     return nuevoArray;
   }

  actualizarBonoVale = (listaPedidosModal, numPedidoVeh) =>{

    numPedidoVeh = numPedidoVeh.map(entry => {return entry.numPedidoVeh}).toString()


    this.setState({muestraLoad:'block'});

    const codColaborador = [];
    this.state.colaboradoresSeleccionados.map(Rows => (
      codColaborador.push(Rows.id)
    ));

    let valEstado = '';
    let newlistaBonos=[];
    let newListaBonosXEstado = [];
    let obsBono='';
    switch (this.state.selectTipoBono) {
      case 'CORTESIA-A':
        newlistaBonos = this.state.listaSeleceCortesia;
        newListaBonosXEstado = listaPedidosModal;
        valEstado = ESTADO_APROBADO;
        obsBono = 'Aprobacion de vale por cortesia, para los pedidos N° '+ numPedidoVeh;
        break;
      case 'CORTESIA-R':
        newlistaBonos = this.state.listaSeleceCortesia;
        newListaBonosXEstado = listaPedidosModal;
        valEstado = ESTADO_RECHAZADO;
        obsBono = 'Rechazo de vale por cortesia, para los pedidos N° '+ numPedidoVeh;
        break;

     case 'CORTESIA-I':
        newlistaBonos = this.state.listaSelecedBonos;
        newListaBonosXEstado = listaPedidosModal;
        valEstado = ESTADO_INACTIVAR;
        obsBono = 'Inactivacion de vale por cortesia, para los pedidos N° '+ numPedidoVeh;
        break;

      case 'BONOS-A':
        newlistaBonos = this.state.listaSelecedBonos;
        newListaBonosXEstado = listaPedidosModal;
        obsBono = 'Aprobacion de vale de proforma, para los pedidos N° '+ numPedidoVeh;
        valEstado = ESTADO_APROBADO;
        break;
      case 'BONOS-R':
        newlistaBonos = this.state.listaSelecedBonos;
        newListaBonosXEstado = listaPedidosModal;
        valEstado = ESTADO_RECHAZADO;
        obsBono = 'Rechazo de vale de proforma, para los pedidos N° '+ numPedidoVeh;
        break;

      case 'BONOS-I':
        newlistaBonos = this.state.listaSelecedBonos;
        newListaBonosXEstado = listaPedidosModal;
        valEstado = ESTADO_INACTIVAR;
        obsBono = 'Inactivacion de vale de proforma, para los pedidos N° '+ numPedidoVeh;
        break;

      default:
        break;
    }

    console.log('newListaBonosXEstado',newListaBonosXEstado);

    newListaBonosXEstado.forEach((items) =>{
      let pedido={};
      pedido = items;
      updateEstadoVale(
        pedido.codFiveBono,
        pedido.codValeFiveBono,
        pedido.numFichaVtaVeh,
        pedido.numProfVeh,
        valEstado,
        codColaborador,
        obsBono + '<br><br> Monto: '+ pedido.montoVale + ', Cantidad: ' + pedido.canValeBono
      ).then((result) => {
        this.renderLoad();

      });
    });
    this.setState({
      modalOpenvalue: false,
      muestraLoad:'none'});
  }

  seleccionarBonos = (id) => {
    if (this.state.listaSelecedBonos.indexOf(id)>=0) {
      this.setState({
        listaSelecedBonos:this.state.listaSelecedBonos.filter(x => x !== id)
      });
    } else {
      this.setState({
        listaSelecedBonos: [...this.state.listaSelecedBonos, id],
      });
    }
  }

  seleccionarCortesia = (id) => {
    if (this.state.listaSeleceCortesia.indexOf(id)>=0) {
      this.setState({
        listaSeleceCortesia:this.state.listaSeleceCortesia.filter(x => x !== id)
      });
    } else {
      this.setState({
        listaSeleceCortesia: [...this.state.listaSeleceCortesia, id],
      });
    }

  }


  modalOpenAcctionAprobar = (codFiveBono) =>{
    this.setState({listaPedidosModal:[]});
    this.setState({
          modalOpenvalue: true,
          title:'Aprobar aplicación de bonos de cortesía',
          subtitle:'Se Aprobaran los bonos a los siguientes pedidos:',
          listaPedidosModal:this.state.listaBonoXCortesia.filter(entry => entry.codFiveBono===codFiveBono),
          selectTipoBono:'CORTESIA-A'});
  }

  modalOpenAcctionRechazar = (codFiveBono) =>{
    this.setState({listaPedidosModal:[]});
    this.setState({
      modalOpenvalue: true,
      title:'Aprobar aplicación de bonos de cortesía',
      subtitle:'Se Rechazarán  los bonos a los siguientes pedidos:',
      listaPedidosModal:this.state.listaBonoXCortesia.filter(entry => entry.codFiveBono===codFiveBono),
      selectTipoBono:'CORTESIA-R'});

  }

  modalOpenAcctionInactivar = (codFiveBono) =>{

    this.setState({listaPedidosModal:[]});
    this.setState({
      modalOpenvalue: true,
      title:'Inactivar bonos de cortesía',
      subtitle:'Se Inactivaran los bonos a los siguientes pedidos:',
      listaPedidosModal:this.state.listaBonoXCortesia.filter(entry => entry.codFiveBono===codFiveBono),
      selectTipoBono:'CORTESIA-I'});

  }


  modalOpenAcctionAprobarBonos = (codFiveBono) =>{

    this.setState({listaPedidosModal:[]});
    this.setState({
      modalOpenvalue: true,
      title:'Aprobar aplicación de bonos de proforma',
      subtitle:'Se Aprobaran los bonos a los siguientes pedidos:',
      listaPedidosModal:this.state.listaBonosXproforma.filter(entry => entry.codFiveBono===codFiveBono),
      selectTipoBono:'BONOS-A'});
  }

  modalOpenAcctionRechazarBonos = (codFiveBono) =>{

    this.setState({listaPedidosModal:[]});
    this.setState({
      modalOpenvalue: true,
      title:'Rechazar aplicación de bonos de proforma',
      subtitle:'Se Rechazarán los bonos a los siguientes pedidos:',
      listaPedidosModal:this.state.listaBonosXproforma.filter(entry => entry.codFiveBono===codFiveBono),
      selectTipoBono:'BONOS-R'});

  }

  modalOpenAcctionInactivarBonos = (codFiveBono) =>{

    this.setState({listaPedidosModal:[]});
    this.setState({
      modalOpenvalue: true,
      title:'Inactivar bonos de proforma',
      subtitle:'Se Inactivaran los bonos a los siguientes pedidos:',
      listaPedidosModal:this.state.listaBonosXproforma.filter(entry => entry.codFiveBono===codFiveBono),
      selectTipoBono:'BONOS-I'});
  }


  registrarBonos = (regitroListaBonos) =>{
    console.log(regitroListaBonos);
  }

  openModal = (nameModal,props,pedidos) =>{
    this.setState({pedidosToEdit:pedidos!==undefined?pedidos.map(entry => {return entry.numPedidoVeh}):[]})

    this.setState({pedidosToEditCodFiv:pedidos!==undefined?pedidos.map(entry => {return {numPedidoVeh:entry.numPedidoVeh,codFiveBono:entry.codFiveBono}}):[]})
    if(nameModal === 'AgregarBonos'){
      getBonos(this.props.fdvID,this.props.proformaSeleccionada).then((result) => {
        if(result.data.bonoProforma.length>0){
          this.setState({montoBonoProforma:result.data.bonoProforma[0].valorTotalBono,
          codMonedaBono: result.data.bonoProforma[0].codMonedaEquipoLocal,});
          this.setState({nameModalValue:nameModal,isOpen:true});
        }else{
          this.openAlertSuccess();
        }
      });
    }else {
      this.setState({nameModalValue:nameModal,isOpen:true});
    }
  }

  setReInitialize=()=>{
    this.setState({pedidosToEdit:[]})
  }


  editBonosVale=()=>{
    editBonosVale();
  }

  printcontent = (content)=>
  {
      return {__html:content};
  }



  render(){

    return(
      <div>
        <TabBonos
          modalOpenAcctionAprobar = {this.modalOpenAcctionAprobar}
          modalOpenAcctionRechazar = {this.modalOpenAcctionRechazar}
          modalOpenAcctionInactivar = {this.modalOpenAcctionInactivar}
          modalOpenAcctionAprobarBonos = {this.modalOpenAcctionAprobarBonos}
          modalOpenAcctionRechazarBonos = {this.modalOpenAcctionRechazarBonos}
          modalOpenAcctionInactivarBonos = {this.modalOpenAcctionInactivarBonos}
          pedidos={this.props.facturacion}
          addPedidosAsignarBonos = {this.props.addPedidosAsignarBonos}
          arrayAsignarBonos={this.props.arrayAsignarBonos}
          fdvID={this.props.fdvID}
          proformas={this.props.proformas}
          proformaSeleccionada={this.props.proformaSeleccionada}
          selectProforma={this.props.selectProforma}
          listaBonosXproforma = {this.state.listaBonosXproforma}
          listaBonoXCortesia = {this.state.listaBonoXCortesia}
          listaPedidosXCortesia ={this.state.listaPedidosXCortesia}
          listaPedidosXProforma = {this.state.listaPedidosXProforma}
          listaSelecedBonos = {this.state.listaSelecedBonos}
          seleccionarBonos = {this.seleccionarBonos}
          seleccionarCortesia = {this.seleccionarCortesia}
          listaSeleceCortesia = {this.state.listaSeleceCortesia}
          showModalBonos = {this.showModalBonos}
          registrarBonos = {this.registrarBonos}
          clearProforma = {this.clearProforma}
          openModal ={this.openModal}
          eliminarObjetosDuplicados = {this.eliminarObjetosDuplicados}
          step={this.state.step}
          printcontent={this.printcontent}
          colaboradores={this.props.colaboradores}
          changeColaborador={this.changeColaborador}
          selectColaborador={this.selectColaborador}
          colaboradoresSeleccionados={this.state.colaboradoresSeleccionados}
          handlePermissions={this.props.handlePermissions}
          /*Inicio Req 92293 ebarboza 26 07 2021 */
          codMonedaBono = {this.props.proformas[0].tipoMoneda}
          /*Fin Req 92293 ebarboza 26 07 2021 */
        />
        <ModalBonos
          closeModal = { this.closeModal}
          listaPedidosModal={this.state.listaPedidosModal}
          modalOpenvalue = {this.state.modalOpenvalue}
          title = {this.state.title}
          subtitle = {this.state.subtitle}
          ejecuntar = {this.ejecuntar}
          actualizarBonoVale = {this.actualizarBonoVale}
          selectTipoBono = {this.state.selectTipoBono}
          listaPedidosXProforma = {!this.state.selectTipoBono.indexOf("BONO")?this.state.listaPedidosXProforma:this.state.listaPedidosXCortesia}
          renderLoad={this.renderLoad}
          colaboradores={this.props.colaboradores}
          changeColaborador={this.changeColaborador}
          selectColaborador={this.selectColaborador}
          colaboradoresSeleccionados={this.state.colaboradoresSeleccionados}
          colaborador={this.state.colaborador}
          removeColaborador = {this.removeColaborador}
        />

        {
          this.state.nameModalValue === 'AgregarBonos' ?(
            <AgregarBonos
                closeModal={this.closeModal}
                pedidos={this.state.pedidosXfichaVenta}
                addPedidosAsignarBonos = {this.addPedidosAsignarBonos}
                arrayAsignarBonos={this.props.arrayAsignarBonos}
                fdvID={this.props.fdvID}
                profroma = {this.props.proformaSeleccionada}
                registrarBonos = {this.registrarBonos}
                flagBonos = {'AgregarBonos'}
                renderLoad = {this.renderLoad}
                isOpen = {this.state.isOpen}
                openAlertSuccess = {this.openAlertSuccess}
                codMonedaBono = {this.state.codMonedaBono}
                montoBonoProforma = {this.state.montoBonoProforma}
                flagActionTab = {this.state.flagActionTab}
                listaPedidosXProforma = {this.state.listaPedidosXProforma}
                nextStep={this.nextStep}
                previousStep={this.previousStep}
                step={this.state.step}
                callFromTabFacturacion={1}
                pedidosToEdit={this.state.pedidosToEdit}
                setReInitialize={this.setReInitialize}
                listaBonosXproforma={this.state.listaBonosXproforma}
                pedidosToEditCodFiv={this.state.pedidosToEditCodFiv}
                colaboradores={this.props.colaboradores}
                changeColaborador={this.changeColaborador}
                selectColaborador={this.selectColaborador}
                colaboradoresSeleccionados={this.state.colaboradoresSeleccionados}

          />
          ):(
            null
          )
        }

        {
          this.state.nameModalValue === 'AgregarCortesia' ?(
            <AgregarBonos
              closeModal={this.closeModal}
              pedidos={this.state.pedidosXfichaVenta}
              addPedidosAsignarBonos = {this.addPedidosAsignarBonos}
              arrayAsignarBonos={this.props.arrayAsignarBonos}
              fdvID={this.props.fdvID}
              profroma = {this.props.proformaSeleccionada}
              registrarBonos = {this.registrarBonos}
              flagBonos = {'AgregarCortesia'}
              renderLoad = {this.renderLoad}
              isOpen = {this.state.isOpen}
              codMonedaBono = {this.state.codMonedaBono}
              montoBonoProforma = {this.state.montoBonoProforma}
              flagActionTab = {this.state.flagActionTab}
              nextStep={this.nextStep}
              previousStep={this.previousStep}
              step={this.state.step}
              callFromTabFacturacion={1}
              pedidosToEdit={this.state.pedidosToEdit}
              pedidosToEditCodFiv={this.state.pedidosToEditCodFiv}
              listaBonosXproforma={this.state.listaBonoXCortesia}
              colaboradores={this.props.colaboradores}
              changeColaborador={this.changeColaborador}
              selectColaborador={this.selectColaborador}
              colaboradoresSeleccionados={this.state.colaboradoresSeleccionados}

          />
          ):(null)

        }

        {
                this.state.alertSuccessOpen &&
                <Alert type='alert-success' icon='ion-checkmark-circled' closeAlert={this.closeAlertSuccess} >
                <p>La Proforma {this.props.proformaSeleccionada} no tiene un Bono</p>
                </Alert>
        }

        {
          this.props.colaboradores && this.props.colaboradores.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar colaboradores</p>
            </Alert> : null
        }

        {
          this.props.facturacion && this.props.facturacion.error ?
            <Alert type='alert-danger alertModal' icon='ion-alert-circled'>
              <p>Hubo un error con el servicio de listar facturacion</p>
            </Alert> : null
        }

        <div className='modal extraFilter' role='dialog' data-backdrop='static' style={{ zIndex: '2000', display: this.state.muestraLoad }} >
          <div className='modal-dialog modal-sm' role='document'>
            <FadeLoader color={'#F8A14A'} loading />
          </div>
        </div>
      </div>
    )
  }
}


function mapStateToProps(state) {
  return {
    facturacion: state.facturacion,
    colaboradores : state.colaboradores,
  };
}

Bonos.defaultProps = {
  facturacion: [],

};
export default connect(mapStateToProps,
  {
    fetchFacturacion,clearColaboradores,fetchColaboradores
  })(Bonos);



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Bonos/Bonos.js